// src/pages/Portfolio.jsx
import React from 'react'
import EducaHero from '../../components/projectenpruduct' // ← verify the correct path/name
import Faq from '../../components/faq'
import Port from '../../components/Portfolio'
import Testimonials from '../../components/Testimonials'
import CallToAction from '../../components/CallToAction'
import { useTranslation } from 'react-i18next';

function Portfolio() {
  const { t } = useTranslation();

  return (
    // Adjust these values to your real header height (e.g. 64/72/80px)
    <main className="pt-[72px] md:pt-[88px] lg:pt-[96px]">
      <EducaHero />

      <div className="pt-28">
        <Port />

        <div className="mt-16">
          <Testimonials />
        </div>

        <div className="mt-16">
          <CallToAction 
            title={t('portfolio2.cta.title')} 
            description={t('portfolio2.cta.description')} 
            buttonText={t('portfolio2.cta.button')} 
          />
        </div>

        <div className="mt-20">
          <Faq />
        </div>
      </div>
    </main>
  )
}

export default Portfolio
